import React from 'react';
import { Button } from '@mui/material';

const CustomButton = ({
    children,
    variant = 'contained',
    size = 'medium',
    ...props
}) => {
    return (
        <Button
            variant={variant}
            size={size}
            sx={{
                backgroundColor: 'var(--forbrand-bg-variant)',
                color: 'var(--forbrand-brand-varient)',
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '16px',
            }}
            {...props}
        >
            {children}
        </Button>
    );
};

export default CustomButton; 